export default "__VITE_ASSET__C2cfcQ4V__"